const downArrow = <svg
    className="absolute mt-1 h-3/6 right-1.5"
    fill="#8C013C"
    stroke="currentColor"
    viewBox="0 0 210 297"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M 93.716178,165.59702 C 91.808506,164.19743 85.713935,158.29433 80.17274,152.47902 74.631518,146.66371 56.896285,128.67065 40.761123,112.49445 16.156348,87.827087 11.30381,82.548249 10.676483,79.766824 c -1.5612803,-6.922563 2.455545,-13.849477 8.993479,-15.50898 7.479692,-1.898547 7.091786,-2.209845 46.352147,37.197466 l 36.250621,36.38631 36.23188,-36.38907 c 39.24403,-39.414341 38.84636,-39.095108 46.33338,-37.194706 6.53791,1.659503 10.55476,8.586417 8.99346,15.50898 -0.62712,2.780554 -5.4845,8.067983 -30.06577,32.727626 -16.1248,16.1762 -34.22645,34.52228 -40.22593,40.76905 -13.0316,13.56884 -14.92194,14.87822 -21.47967,14.87822 -3.963512,0 -5.524102,-0.47594 -8.343902,-2.5447 z" />
</svg>

export default downArrow